import { PriceInterval } from '@griply/types';

const priceIntervals: string[] = Object.values(PriceInterval);

export const getInitialPriceSelection = (type?: string): PriceInterval =>
  priceIntervals.includes(type ?? '')
    ? (type as PriceInterval)
    : PriceInterval.Year;
